import { createActions } from 'reduxsauce';
const { Types, Creators } = createActions({
  getListApprovalTicket: ['params'],
  getListApprovalTicketSuccess: ['dataApprovalInit'],
  getListApprovalTicketFail: [],
  getMoreListApproval: ['params'],
  getMoreListApprovalSuccess: ['dataMoreApproval'],
  getMoreListApprovalFail: [],
  searchApprovalTicket: ['params'],
  searchApprovalTicketSuccess: ['dataSearchApproval'],
  searchApprovalTicketFail: [],
  getMoreListApprovalWithSearch: ['params'],
  getMoreListApprovalSuccessWithSearch: ['dataMoreApproval'],
  getMoreListApprovalWithSearchFail: [],
});
export const TicketApprovalTypes = Types;
export default Creators;
